namespace Solovis.Reports.Parts.Tables.DataTableHelpers.TableModel {
    /*
     * TableModel contains helpers for working with the table model rows and columns.
     */

    export function flattenVisibleRows(sourceRows, flattenOptions) {
        /// <summary>
        /// flattenVisibleRows will flatten the visible rows into containers that have the row (or group row) and level depth,
        /// so that we can easily see the complete list of visible rows (and in the future, support virtual scrolling).
        /// sourceRows will be hierarchical in nature, where groups have references to child rows.
        /// flattenOptions can have { aggregateRowDisplay: "inline/top/bottom", isExpandedCallback: function(nestedGroupKey) { returns true/false } } 
        /// </summary>

        var rowList = [];

        var aggregateDisplay = flattenOptions.aggregateRowDisplay ? flattenOptions.aggregateRowDisplay : "top";
        var isExpandedCallback = flattenOptions.isExpandedCallback ? flattenOptions.isExpandedCallback : function () { return true };

        if (flattenOptions.tableSettingsToUse && flattenOptions.tableSettingsToUse.aggregateRowDisplay) {
            aggregateDisplay = flattenOptions.tableSettingsToUse.aggregateRowDisplay;
        }

        TableModel._flattenVisibleRowsHelper(sourceRows, rowList, 0, null, aggregateDisplay, isExpandedCallback);

        return rowList;
    };

    export function _flattenVisibleRowsHelper(sourceRowList, targetRowList, level, parentRowData, aggregateDisplay, isExpandedCallback) {
        if (sourceRowList) {
            $(sourceRowList).each(function (rowIndex, row: any) {
                var aggregateDisplayToUse = aggregateDisplay;
                if (row._subRowReplacement) {
                    // We always use inline aggregates when processing a row created by subrow processing.
                    aggregateDisplayToUse = "inline";
                }

                if (row._groupId) {
                    var rowData: any = {
                        parentRow: parentRowData,
                        row: row,
                        level: level,
                        inlineAggregates: aggregateDisplayToUse == "inline",
                        isGroupHeader: true
                    };

                    var nestedGroupKey = row._nestedGroupKey;
                    rowData.nestedGroupKey = nestedGroupKey;

                    targetRowList.push(rowData);

                    var aggregateRowData = null;
                    if (aggregateDisplayToUse == "top" || aggregateDisplayToUse == "bottom") {
                        aggregateRowData = {
                            parentRow: parentRowData,
                            row: row,
                            level: level,
                            isAggregateRow: true
                        };
                    }

                    if (aggregateDisplayToUse == "top" && (row._groupTotals || row._backingRow)) {
                        targetRowList.push(aggregateRowData);
                    }

                    // Flatten child rows.
                    if (row._rows) {
                        if (isExpandedCallback(nestedGroupKey)) {
                            rowData.expanded = true;

                            TableModel._flattenVisibleRowsHelper(row._rows, targetRowList, level + 1, rowData, aggregateDisplayToUse, isExpandedCallback);
                        }
                        else {
                            rowData.expanded = false;
                        }
                    }

                    if (aggregateDisplayToUse == "bottom" && (row._groupTotals || row._backingRow)) {
                        targetRowList.push(aggregateRowData);
                    }
                }
                else {
                    var rowData: any = {
                        parentRow: parentRowData,
                        row: row,
                        level: level
                    };

                    targetRowList.push(rowData);
                }
            });
        }
    };


    export function processSubRowFactory(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter) {
        TableModel._processSubRowFactoryForLevel(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter, 0, null);
    };

    export function _processSubRowFactoryForLevel(tableControl, processedRows, subRowFactory, subRowGroupKeyGetter, level, parentNestedGroupKey) {
        $(processedRows).each(function (i, row: any) {
            if (row._rows) {
                TableModel._processSubRowFactoryForLevel(tableControl, row._rows, subRowFactory, subRowGroupKeyGetter, level + 1, row._nestedGroupKey);
            }
            else {
                var subRows = subRowFactory.call(tableControl, row);
                if (!_.isEmpty(subRows)) {
                    var groupKey = subRowGroupKeyGetter(row);
                    var nestedGroupKey;
                    if (parentNestedGroupKey) {
                        nestedGroupKey = parentNestedGroupKey + "||" + groupKey;
                    }
                    else {
                        nestedGroupKey = groupKey;
                    }

                    var replacementRow: any = { _subRowReplacement: true, _backingRow: row };
                    replacementRow._groupKey = groupKey;
                    replacementRow._nestedGroupKey = nestedGroupKey;
                    replacementRow._groupId = "subRowFactory";
                    replacementRow._rows = subRows;

                    // Place in original slot in processedRows.
                    processedRows[i] = replacementRow;
                }
            }
        });
    };
}
